module.exports = __webpack_public_path__ + "img/store-black.04e6c86e.svg";